import type { JSX } from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';

export function PageHeading(): JSX.Element {
	return (
		<div className="container mb-10">
			<Text variant="heading" size="x-large" as="h1" className="mb-6 capitalize">
				<Translate value="fe.pages.about.section_business_model.header" />
			</Text>
		</div>
	);
}
